import React from 'react';
import PropTypes from 'prop-types';

import { DRAG_TYPES } from '@techchange/dnd';

import { useFormEditorContext } from '../contexts/FormEditorContext';
import {
	FIELD_EDITOR_FIELDS,
	OPTION_EDITOR_FIELDS,
	SECTION_EDITOR_FIELDS,
} from '../hooks/useFormEditorData';
import {
	formSectionDataShape,
	formFieldDataShape,
	formFieldOptionDataShape,
} from '../utils/propTypes';

const propTypes = {

	/**
	 * The dragged item to preview.
	 */
	item: PropTypes.shape({

		/**
		 * The drag-and-drop type of the dragged item, provided by react-dnd.
		 */
		type: PropTypes.string.isRequired,

		/**
		 * The original data for the dragged item.
		 */
		data: PropTypes.oneOfType([
			formSectionDataShape,
			formFieldDataShape,
			formFieldOptionDataShape,
		]).isRequired,

	}),

};

/**
 * Renders the drag preview for a form editor item.
 *
 * @param   {object} props  The component props.
 *
 * @returns {node}          The rendered drag preview for the item.
 */
const FormEditorDragPreview = ({ item }) => {

	const { selectedLanguage } = useFormEditorContext();

	if (item.type === DRAG_TYPES.FORM_SECTION) {

		// Get the form section content data for the selected language
		const activeTranslation = item.data[SECTION_EDITOR_FIELDS.CONTENTS]
			.find((content) => content.language === selectedLanguage);

		return (
			<h5>
				{activeTranslation?.[SECTION_EDITOR_FIELDS.TITLE]}
			</h5>
		);

	} else if (item.type === DRAG_TYPES.FORM_FIELD) {

		// Get the form section content data for the selected language
		const activeTranslation = item.data[FIELD_EDITOR_FIELDS.CONTENTS]
			.find((content) => content.language === selectedLanguage);

		return (
			<p className="fw-bold">
				{activeTranslation?.[FIELD_EDITOR_FIELDS.TITLE]}
			</p>
		);

	} else if (item.type === DRAG_TYPES.FORM_FIELD_OPTION) {

		// Get the form section content data for the selected language
		const activeTranslation = item.data[OPTION_EDITOR_FIELDS.CONTENTS]
			.find((content) => content.language === selectedLanguage);

		return (
			<p>
				{activeTranslation?.[OPTION_EDITOR_FIELDS.LABEL]}
			</p>
		);

	}

	console.warn(`The drag type has no support for a drag preview: ${item.type}`);
	return null;

};

FormEditorDragPreview.propTypes = propTypes;

export default FormEditorDragPreview;
